import { render, staticRenderFns } from "./emptyData.vue?vue&type=template&id=cf4eb7f0&scoped=true&"
import script from "./emptyData.vue?vue&type=script&lang=js&"
export * from "./emptyData.vue?vue&type=script&lang=js&"
import style0 from "./emptyData.vue?vue&type=style&index=0&id=cf4eb7f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4eb7f0",
  null
  
)

export default component.exports